import { c as _c } from "react/compiler-runtime";
import { Application, LeadCreationAction, LeadCreationResponse } from "@justhome/api-core";
import { GTM_EVENT_CONTACT_WALL } from "@lib/constants";
import gtm from "@lib/gtm";
import useLinks from "@lib/hooks/useLinks";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import { ApplicationFormValues } from "@lib/mapApplicationData/types";
import useApplicationContext from "@modules/application/hooks/useApplicationContext";
import usePostApplicationWithLead from "@modules/application/hooks/usePostApplicationWithLead";
import { useRouter } from "@lib/hooks/useRouter";
import { FC, useEffect } from "react";
import LeadWall from "../../../../components/LeadWall";
import { Slide } from "../../../../components/LeadWall/types";
import ApplicationLayout from "../ApplicationLayout";
import { FormStepComponent } from "../FormSteps/FormSteps";
export interface ApplicationLeadWallComponentProps extends FormStepComponent<ApplicationFormValues> {
  title: string;
  description: string;
  listItems: string[];
  leadCreationAction: LeadCreationAction;
  slides: Slide[];
}
const ApplicationLeadWallComponent: FC<ApplicationLeadWallComponentProps> = t0 => {
  const $ = _c(22);
  const {
    value,
    title,
    description,
    listItems,
    leadCreationAction,
    slides
  } = t0;
  const {
    state,
    dispatch
  } = useApplicationContext();
  const {
    partner
  } = usePartnerContext();
  const router = useRouter();
  const {
    getApplicationProcessLink
  } = useLinks();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] !== router) {
    t2 = () => {
      router.back();
    };
    $[1] = router;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleGoBack = t2;
  let t3;
  if ($[3] !== dispatch || $[4] !== getApplicationProcessLink || $[5] !== router) {
    t3 = (application, lead) => {
      dispatch({
        type: "SET_APPLICATION",
        application
      });
      dispatch({
        type: "SET_LEAD",
        lead
      });
      router.push(getApplicationProcessLink(lead.isOffersViewForbidden ? "forbidden" : "offers"));
    };
    $[3] = dispatch;
    $[4] = getApplicationProcessLink;
    $[5] = router;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleFirstStepSuccess = t3;
  const t4 = value as ApplicationFormValues;
  let t5;
  if ($[7] !== handleFirstStepSuccess || $[8] !== leadCreationAction || $[9] !== partner || $[10] !== t4) {
    t5 = {
      partner,
      leadCreationAction,
      applicationForm: t4,
      onSuccess: handleFirstStepSuccess
    };
    $[7] = handleFirstStepSuccess;
    $[8] = leadCreationAction;
    $[9] = partner;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const {
    isLoading,
    isError,
    handleSubmit
  } = usePostApplicationWithLead(t5);
  let t6;
  if ($[12] !== description || $[13] !== handleGoBack || $[14] !== handleSubmit || $[15] !== isError || $[16] !== isLoading || $[17] !== listItems || $[18] !== slides || $[19] !== state.lead || $[20] !== title) {
    t6 = <ApplicationLayout className="h-full py-2s pb-xl m:pb-none"><LeadWall title={title} description={description} listItems={listItems} onSubmit={handleSubmit} isError={isError} isLoading={isLoading} defaultValues={state.lead} slides={slides} onPrevious={handleGoBack} /></ApplicationLayout>;
    $[12] = description;
    $[13] = handleGoBack;
    $[14] = handleSubmit;
    $[15] = isError;
    $[16] = isLoading;
    $[17] = listItems;
    $[18] = slides;
    $[19] = state.lead;
    $[20] = title;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
};
export default ApplicationLeadWallComponent;
function _temp() {
  gtm.event(GTM_EVENT_CONTACT_WALL);
}